import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { getLeverage } from '@ui/utils/trade/getLeverage';

import { useWithdrawCollateralInput } from './useWithdrawCollateralInput';

export const useLeverageChangeLatestPrice = ({
  position,
}: {
  position: Position;
}) => {
  const price = usePayTokenPriceLatest(position.collateralToken);
  const { input } = useWithdrawCollateralInput();
  if (!price) return undefined;
  const collateralUsd = position.getCollateralUsd(price);
  const nextCollateralUsd = collateralUsd.minus(input.value.usd ?? 0);

  return {
    prev: position.getLeverage({
      collateralTokenMarketPrice: price,
    }),

    next: getLeverage({
      collateralUsd: nextCollateralUsd,
      sizeUsd: position.size.times(position.entryPrice),
    }),
  };
};

export const useLeverageChange = useLeverageChangeLatestPrice;
